export var EVENT_SESSION_SERVICE_STATE_CHANGED = 'wh.common.event.sessionService.state.changed';
export var COMMAND_SESSION_SERVICE_STATE_GET = 'wh.common.command.sessionService.state.get';
export var EVENT_SESSION_SERVICE_STATE_GET = 'wh.common.event.sessionService.state.get';

export var commandMyAccountStart = {
  topic: 'wh.common.command.account.action.execute',
  data: {
    eventId: 'event.account.myaccount.start.requested'
  }
};

export var commandMyAccountCancel = {
  topic: 'wh.common.command.account.action.execute',
  data: {
    eventId: 'event.account.myaccount.cancel.requested'
  }
};